import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import {
  InsuranceQuestionnaireRequest,
  QineticNegotiationApi,
} from "../../orchestrator-api-client";
import { YesNo } from "../../enums/yes-no.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitCoherenceQuestionnaire = createAsyncThunk<
  void,
  { data: Record<string, YesNo | "">; offerId: string | undefined },
  ThunkApi
>(
  "submitCoherenceQuestionnaire",
  async (args, { rejectWithValue, getState }) => {
    try {
      const { data, offerId } = args;
      const {
        loan: { offer },
      } = getState();
      const correctOfferId = offer?.id ?? offerId; //for recovery we need offer id from offer-data api otherwise take offer.id from redux store

      const convertedQuestions = Object.entries(
        data,
      ).reduce<InsuranceQuestionnaireRequest>(
        (acc, [surveyQuestion, surveyAnswer]) => {
          acc.surveyRequests?.push({
            surveyQuestion,
            surveyAnswer,
          });
          return acc;
        },
        {
          surveyRequests: [],
          outcome: undefined,
        },
      );

      if (correctOfferId) {
        await new QineticNegotiationApi().saveInsuranceQuestionnaire(
          correctOfferId,
          convertedQuestions,
        );
      } else {
        throw new Error();
      }
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Salvataggio questionario coerenza cpi",
        description:
          "Non siamo riusciti a salvare le tue domande.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
